<template>

    <div>

      <v-app-bar app>
        <v-btn icon text :to="'/kamus'">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <span>Local Data</span>
      </v-app-bar>

      <v-container>
        <v-list two-line subheader>

          <v-list-item @click.native="">
            <v-list-item-content>
              <v-list-item-title>See History Data</v-list-item-title>
              <v-list-item-subtitle>Last update at 02/04/2020</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click.native="">
            <v-list-item-content>
              <v-list-item-title>Clear Data</v-list-item-title>
              <v-list-item-subtitle>Clean local data</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

        </v-list>
      </v-container>

    </div>
</template>

<script>
import idb from '@/plugins/indexedDB'

export default {
  name: 'Kamus-setting',
  data: () => ({
    alphabets: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    filterAplhabets: 0,
    db: null,
    cats: null,
    ready: false,

    downloadbar: false,

    error: null,
    loading: false,
    keyword: null,
    results: [],

    selected: null,
    sheetModel: false

  }),
  async created () {
    this.results = await idb.getKamusAll()
    if (this.results.length == 0) {
      this.downloadbar = true
      let json = await this.downloadData()
      json = this.addIndexAttributes(json)

      await idb.saveKamusAll(json)
      this.results = await idb.getKamusAll()
      this.downloadbar = false
    }
  },
  methods: {

    addIndexAttributes: function (json) {
      json.forEach((each, i) => {
        json[i].indexWord = json[i].word.trim().charAt(0).toUpperCase()
      })

      return json
    },

    say: async function (item) {
      const word = item.word + ' adalah ' + item.description

      const utterThis = new SpeechSynthesisUtterance(word)
      utterThis.lang = 'id'

      speechSynthesis.speak(utterThis)
    },
    async downloadData () {
      var url = 'dictionary'
      return await this.$axios
        .get(url)
        .then(response => {
          return response.data.results
        })
        .catch(error => {
          this.error = true
          this.downloadbar = false
        })
    },

    openSheet: function (item) {
      this.selected = item
      this.sheetModel = true
    }

  },
  computed: {

    items () {
      if (this.keyword) {
        const keyword = this.keyword.toLowerCase()
        return this.results.filter(result => result.word.toLowerCase().includes(keyword) || result.description.toLowerCase().includes(keyword))
      }

      if (this.filterAplhabets) {
        return this.results.filter(result => result.indexWord.toUpperCase() === this.alphabets[this.filterAplhabets].toUpperCase())
      }

      return this.results.filter(result => result.indexWord.toUpperCase() === this.alphabets[0].toUpperCase())
    }

  }
}
</script>
